'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter, useSearchParams } from 'next/navigation';
import type { CategoriesQuery } from '../../../../../../graphql/generated/schema';
import { Container } from '../../../../../../components/layouts';
import { Button, SearchInput } from '../../../../../../components';
import styles from './styles.module.scss';

interface Props {
  categories: Extract<CategoriesQuery['Categories'], { __typename?: 'Categories' }>['docs']
  currentCategorySlug: string;
  search?: string
}

export const ArticlesFilter: React.FC<Props> = ({
  categories,
  currentCategorySlug,
  search,
}) => {
  const router = useRouter();
  const searchParams: Record<string, string> = {};
  useSearchParams().forEach((value, key) => {
    searchParams[key] = value;
  });

  const createPageQuery = (omit?: string[]): Record<string, string | number> => ({
    ...Object.keys(searchParams).reduce((acc, key) => {
      if (!['page', ...(omit || [])].includes(key)) {
        acc[key] = searchParams[key];
      }
      return acc;
    }, {} as Record<string, string>),
  });

  return (
    <Container className={styles.container}>
      <div className={styles.linksContainer}>
        <Link
          href={{
            pathname: '/articles',
            query: createPageQuery(['tag']),
          }}
          className={styles.link}
        >
          <Button
            className={styles.button}
            type={!currentCategorySlug ? 'primary' : 'tertiary'}
            htmlElement="span"
          >
            All
          </Button>
        </Link>
        {
          categories?.map((category) => category && (
            <Link
              href={{
                pathname: `/articles/${category.slug}`,
                query: createPageQuery(['tag']),
              }}
              key={category.id}
              className={styles.link}
            >
              <Button
                className={styles.button}
                type={currentCategorySlug === category.slug ? 'primary' : 'tertiary'}
                htmlElement="span"
              >
                {category.title}
              </Button>
            </Link>
          ))
        }
      </div>
      <div>
        <SearchInput
          containerClassName={styles.searchInputContainer}
          placeholder="Search Articles and Topics"
          initialValue={search}
          onChange={(val) => {
            if (currentCategorySlug) {
              router.push(
                `/articles/${currentCategorySlug}?${new URLSearchParams({
                  ...createPageQuery(),
                  search: val,
                }).toString()}`,
              );
            } else {
              router.push(
                `/articles?${new URLSearchParams({
                  ...createPageQuery(),
                  search: val,
                }).toString()}`,
              );
            }
          }}
        />
      </div>
    </Container>
  );
};
